import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { TEAM_PEOPLE_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function transfer_team(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(
    [...TEAM_PEOPLE_CACHE_FIELDS, 'person_team_by_pk', 'person_by_pk'],
    cache,
  );
}
